(() => {
  const key = 'rr-staff-style-visible';
  let enabled = false;
  const apply = () => document.documentElement.toggleAttribute('data-rr-staff-style-visible', enabled);
  const read = () => {
    try {
      let value = localStorage.getItem(key);
      if (value === null) {
        value = sessionStorage.getItem(key);
        if (value !== null) localStorage.setItem(key, value);
      }
      sessionStorage.removeItem(key);
      enabled = value === 'true';
    } catch {}
    apply();
  };
  read();
  window.addEventListener('pageshow', read);
  window.addEventListener('storage', event => {
    if (event.key === null || event.key === key) read();
  });
  window.addEventListener('rr:staff-style-change', event => {
    enabled = event.detail.enabled;
    apply();
  });
  document.addEventListener('click', event => {
    if (!event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    const title = event.target.closest?.('a.product-title');
    if (!title?.closest('product-card, .horizontal-product-card')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    enabled = !enabled;
    try { localStorage.setItem(key, String(enabled)); } catch {}
    apply();
    window.dispatchEvent(new CustomEvent('rr:staff-style-change', { detail: { enabled } }));
  }, true);
})();
